function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M45.764 19.241L54 6.698 46.713 0 26.798 19.241H0v11.685l4.796.002c1.41 6.074 5.135 11.339 10.495 14.577V51h23.075v-5.495c5.303-3.297 9.027-8.562 10.438-14.636H53.6V22.771v-3.53h-7.836zm.82-14.545l3.39 3.058-9.316 11.487h-7.483L46.583 4.696zM34.527 42.613v4.453H19.013v-4.453c-4.569-2.488-8.915-6.712-10.326-11.744H44.91c-.755 5.4-4.215 9.314-10.38 11.744zM49.82 27.05H3.78v-3.934h46.095v3.934h-.055z"
});

var SvgMortar = function SvgMortar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/mortar.b06cb21a.svg";
export { SvgMortar as ReactComponent };